import * as types from './types';

const initialState = {
  frontPageImage: {
    src: '/images/thumbnails/01-MRFL-100.jpg',
    caption: '',
    images: [
      {
        src: '/images/thumbnails/01-MRFL-100.jpg',
        caption: '',
      },
    ],
  },
  images: [
    {
      src: '/images/thumbnails/01-MRFL-100.jpg',
      caption: '01-MRFL-100.jpg',
    },
    {
      src: '/images/thumbnails/02-MRFL-100.jpg',
      caption: '02-MRFL-100.jpg',
    },
    {
      src: '/images/thumbnails/03-MRFL-100.jpg',
      caption: '03-MRFL-100.jpg',
    },
    {
      src: '/images/thumbnails/04-MRFL-100.jpg',
      caption: '04-MRFL-100.jpg',
    },
    {
      src: '/images/thumbnails/05-MRFL-100.jpg',
      caption: '05-MRFL-100.jpg',
    },
    {
      src: '/images/thumbnails/06-MRFL-100.jpg',
      caption: '06-MRFL-100.jpg',
    },
    {
      src: '/images/thumbnails/08-MRFL-100.jpg',
      caption: '08-MRFL-100.jpg',
    },
    {
      src: '/images/thumbnails/09-MRFL-100.jpg',
      caption: '09-MRFL-100.jpg',
    },
    {
      src: '/images/thumbnails/10-MRFL-100.jpg',
      caption: '10-MRFL-100.jpg',
    },
    {
      src: '/images/thumbnails/13-MRFL-100.jpg',
      caption: '13-MRFL-100.jpg',
    },
    {
      src: '/images/thumbnails/14-MRFL-100.jpg',
      caption: '14-MRFL-100.jpg',
    },
    {
      src: '/images/thumbnails/15-MRFL-100.jpg',
      caption: '15-MRFL-100.jpg',
    },
    {
      src: '/images/thumbnails/16-MRFL-100.jpg',
      caption: '16-MRFL-100.jpg',
    },
    {
      src: '/images/thumbnails/21-MRFL-100.jpg',
      caption: '21-MRFL-100.jpg',
    },
    {
      src: '/images/thumbnails/22-MRFL-100.jpg',
      caption: '22-MRFL-100.jpg',
    },
    {
      src: '/images/thumbnails/23-MRFL-100.jpg',
      caption: '23-MRFL-100.jpg',
    },
    {
      src: '/images/thumbnails/24-MRFL-100.jpg',
      caption: '24-MRFL-100.jpg',
    },
    {
      src: '/images/thumbnails/25-MRFL-100.jpg',
      caption: '25-MRFL-100.jpg',
    },
    {
      src: '/images/thumbnails/26-MRFL-100.jpg',
      caption: '26-MRFL-100.jpg',
    },
    {
      src: '/images/thumbnails/27-MRFL-100.jpg',
      caption: '27-MRFL-100.jpg',
    },
    {
      src: '/images/thumbnails/28-MRFL-100.jpg',
      caption: '28-MRFL-100.jpg',
    },
    {
      src: '/images/thumbnails/29-MRFL-100.jpg',
      caption: '29-MRFL-100.jpg',
    },
    {
      src: '/images/thumbnails/30-MRFL-100.jpg',
      caption: '30-MRFL-100.jpg',
    },
    {
      src: '/images/thumbnails/32-MRFL-100.jpg',
      caption: '32-MRFL-100.jpg',
    },
    {
      src: '/images/thumbnails/33-MRFL-100.jpg',
      caption: '33-MRFL-100.jpg',
    },
    {
      src: '/images/thumbnails/34-MRFL-100.jpg',
      caption: '34-MRFL-100.jpg',
    },
    {
      src: '/images/thumbnails/35-MRFL-100.jpg',
      caption: '35-MRFL-100.jpg',
    },
    {
      src: '/images/thumbnails/36-MRFL-100.jpg',
      caption: '36-MRFL-100.jpg',
    },
    {
      src: '/images/thumbnails/37-MRFL-100.jpg',
      caption: '37-MRFL-100.jpg',
    },
    {
      src: '/images/thumbnails/38-MRFL-100.jpg',
      caption: '38-MRFL-100.jpg',
    },
    {
      src: '/images/thumbnails/39-MRFL-100.jpg',
      caption: '39-MRFL-100.jpg',
    },
  ],
  isOpen: false,
  currentImageIndex: 0,
};

function reducer(state = initialState, action) {
  if (!action || !action.type) {
    return state;
  }
  switch (action.type) {
    case types.LIGHTBOX_CLOSE:
      return { ...state, isOpen: false };
    case types.LIGHTBOX_OPEN:
      return { ...state, isOpen: true };
    case types.LIGHTBOX_NEXT_IMAGE:
      return {
        ...state,
        currentImageIndex: (state.currentImageIndex + 1) % state.images.length,
      };
    case types.LIGHTBOX_PREVIOUS_IMAGE:
      return {
        ...state,
        currentImageIndex: state.currentImageIndex
          ? state.currentImageIndex - 1
          : state.images.length - 1,
      };
    default:
      return state;
  }
}

export { reducer as default };



// WEBPACK FOOTER //
// ./src/lightbox/reducer.js